import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const cmpAverageIssueAgeRoute: InvariantJiraRoute = {
	name: 'software-reports-average-issue-age-cmp',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/average-age',
};
